import {IEnumListEntry} from "../definitions";
export const SHOP_CATEGORIES = {
    HIDDEN: "hidden",
    BUILDING: "building",
    PLANT: "plant",
    CREATURE: "creature",
    SPECIAL: "special",
    DECORE: "decore",
    LONG_DECORE: "long_decore"
};


export const SHOP_CATEGORIES_LIST:IEnumListEntry[] = [
    { id: SHOP_CATEGORIES.HIDDEN, label: SHOP_CATEGORIES.HIDDEN },
    { id: SHOP_CATEGORIES.BUILDING, label: SHOP_CATEGORIES.BUILDING },
    { id: SHOP_CATEGORIES.PLANT, label: SHOP_CATEGORIES.PLANT },
    { id: SHOP_CATEGORIES.CREATURE, label: SHOP_CATEGORIES.CREATURE },
    { id: SHOP_CATEGORIES.SPECIAL, label: SHOP_CATEGORIES.SPECIAL },
    { id: SHOP_CATEGORIES.DECORE, label: SHOP_CATEGORIES.DECORE },
    { id: SHOP_CATEGORIES.LONG_DECORE, label: SHOP_CATEGORIES.LONG_DECORE }
];


// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-shop-categories.ts